import { useGlobals } from '@/hooks';
import * as S from './styles';
import { colors } from '@/constants';
import { formatCurrency } from '@/shared';
import { OrderItemsProps } from '@/talons/orderStatusPage/useOrderStatusPage';
import { RiCalendarScheduleLine } from 'react-icons/ri';
import { useEffect, useState } from 'react';

interface CalendarProps {
  date: string;
  total?: number;
  totalComission?: number;
  totalComissionMonth?: number;
  orders?: OrderItemsProps[];
  totalMonth?: number;
}

const Calendar = ({ date, total, totalComission, totalMonth, totalComissionMonth }: CalendarProps) => {
  const { scrollDirection } = useGlobals();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setShow(window.scrollY > 100 && scrollDirection === 'down');
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollDirection]);

  return (
    <S.CalendarContainer $scrolled={show}>
      <S.Row>
        <S.IconContainer>
          <RiCalendarScheduleLine size={21} color={colors.brand.grafite} />
        </S.IconContainer>

        <S.DateContainer>
          <S.Title>Pedido(s) feito(s) em:</S.Title>
          <S.Date>{date}</S.Date>
        </S.DateContainer>
      </S.Row>

      {total && (
        <S.Col>
          <S.TotalsRow>
            <S.Title $textalign="start">
              Total dia:
              <S.Total>{formatCurrency({ value: total || 0 })}</S.Total>
            </S.Title>

            <S.Title $textalign="end">
              Total mês:
              <S.Total>{formatCurrency({ value: totalMonth || 0 })}</S.Total>
            </S.Title>
          </S.TotalsRow>

          <S.TotalsRow>
            <S.Title $textalign="start">
              {!!totalComission && (
                <>
                  Comissão dia:
                  <S.Total>{formatCurrency({ value: totalComission || 0 })}</S.Total>
                </>
              )}
            </S.Title>

            <S.Title $textalign="end">
              {!!totalComissionMonth && (
                <>
                  Comissão Mês:
                  <S.Total>{formatCurrency({ value: totalComissionMonth || 0 })}</S.Total>
                </>
              )}
            </S.Title>
          </S.TotalsRow>
        </S.Col>
      )}
    </S.CalendarContainer>
  );
};

export default Calendar;
